import { ModuleWithProviders, NgModule } from '@angular/core';
import { ToastrModule } from 'ngx-toastr';

import { ToasterContainerComponent } from 'src/app/_shared/toaster/toaster-container.component';
import { ToasterToastComponent } from 'src/app/_shared/toaster/toaster-toast.component';

@NgModule({
  declarations: [ToasterContainerComponent, ToasterToastComponent],
  imports: [ToastrModule],
  exports: [ToasterContainerComponent]
})
export class ToasterModule {
  static forRoot(): ModuleWithProviders<ToasterModule> {
    return {
      ngModule: ToasterModule,
      providers: ToastrModule.forRoot({
        toastComponent: ToasterToastComponent,
        toastClass: 'toast',
        // Same classes as angular2-toaster: icon-<type> for the icon, toast-<type> for the colour.
        iconClasses: {
          error: 'icon-error toast-error',
          info: 'icon-info toast-info',
          success: 'icon-success toast-success',
          warning: 'icon-warning toast-warning'
        }
      }).providers
    };
  }
}
